// extracted by mini-css-extract-plugin
module.exports = {"root":"Cashbacks_qmee_root__zvECR"};